import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { addMultipleColumnDefinitions } from '../columnDefinitionsSlice'
import { ColumnDefinition } from '../models/ColumnDefinition'
import { GridTypeName } from '../models/GridTypeName'

type FetchGridColDefPayload = {
  gridTypeName: GridTypeName
}

export const fetchColumnDefinitions = createAsyncThunk('columnDefinitions/fetchByType', async ({ gridTypeName }: FetchGridColDefPayload, { dispatch }) => {
  const columnDefinitions = await OLMSApiService.get<ColumnDefinition[]>(`/setting/gridColumns/${gridTypeName}`)

  if (columnDefinitions && columnDefinitions.length > 0) {
    dispatch(addMultipleColumnDefinitions(columnDefinitions))
  }
})